/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import config from "../config/settings.config.json";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPresentationsMethods extends IPluginMethodMap {
  getPresentationsProps(args: any): Promise<any>;
}

export class PresentationsService implements IAgentPlugin {
  readonly methods: IPresentationsMethods;

  constructor() {
    this.methods = {
      getPresentationsProps: this.getPresentationsProps.bind(this),
    };
  }

  async getPresentationsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {
              // status: {
              //   eq: "active",
              // },
            },
            options: {
              limit: 20000,
              skip: 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          const presentationsFilter = res?.data?.getPresentations?.content?.map(
            (_item: any) => {
              return { value: _item?.id, label: _item?.name };
            }
          );
          // Updating options under the "Presentation" key
          config.tableHeaders[0].filterTypes.forEach((filter) => {
            if (filter.type === "select") {
              filter.options = presentationsFilter;
            }
          });
          config.tableHeadersAdmin[0].filterTypes.forEach((filter) => {
            if (filter.type === "select") {
              filter.options = presentationsFilter;
            }
          });
          return {
            presentationsFilter: presentationsFilter,
            response: res?.data?.getPresentations?.content,
            settingConfig: config,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
    }
  }
}
